import React from 'react'
import DisabledTabButton from './DisabledTabButton'
import EnabledTabButton from './EnabledTabButton'
import blackDisabledDashboardIcon from '../images/blackDisabledDashboardIcon.svg'
import blackEnabledDashboardIcon from '../images/blackEnabledDashboardIcon.svg'
import blackEnabledEventIcon from '../images/blackEnabledEventIcon.svg'
import blackDisabledEventIcon from '../images/blackDisabledEventIcon.svg'
import blackEnabledTicketIcon from '../images/blackEnabledTicketIcon.svg'
import blackDisabledTicketIcon from '../images/blackDisabledTicketIcon.svg'
import { Redirect } from 'react-router'

class HeaderDashboardByVehicleComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      vehicleNumber: null,
      trackableLabel: null,
      trackableName: null,
      link: null
    }
  }

  onClick (link) {
    this.setState({
      vehicleNumber: this.props.vehicleNumber,
      trackableLabel: this.props.trackableLabel,
      trackableName: this.props.trackableName,
      link: link
    })
  }

  checkDashboardButton () {
    if (this.props.enabled === 'dashbord') {
      return (
        <EnabledTabButton
          img={blackEnabledDashboardIcon}
          label='DASHBOARD'
        />
      )
    }
    return (
      <DisabledTabButton
        img={blackDisabledDashboardIcon}
        label='DASHBOARD'
        onClick={() => this.onClick(`${localStorage.getItem('endpoint')}/dashboard-by-vehicle`)}
      />
    )
  }

  checkEventButton () {
    if (this.props.enabled === 'event') {
      return (
        <EnabledTabButton
          img={blackEnabledEventIcon}
          label={`EVENEMENTS ${this.props.vehicleNumber}`}
        />
      )
    }
    return (
      <DisabledTabButton
        img={blackDisabledEventIcon}
        label={`EVENEMENTS ${this.props.vehicleNumber}`}
        onClick={() => this.onClick(`${localStorage.getItem('endpoint')}/events-by-vehicle`)}
      />
    )
  }

  checkTicketButton () {
    if (this.props.enabled === 'ticket') {
      return (
        <EnabledTabButton
          img={blackEnabledTicketIcon}
          label='TICKETS'
        />
      )
    }
    return (
      <DisabledTabButton
        img={blackDisabledTicketIcon}
        label='TICKETS'
        // onClick={() => this.onClick(`${localStorage.getItem('endpoint')}/tickets-by-vehicle`)}
      />
    )
  }

  render () {
    const vehicleDisplayMode = localStorage.getItem('vehicleDisplayMode') || 'registration'
    const displayValue = vehicleDisplayMode === 'registration' ? this.props.vehicleNumber : this.props.trackableName
    const truncatedValue = displayValue && displayValue.length > 20 ? displayValue.substring(0, 20) + '...' : displayValue

    if (this.state.vehicleNumber) {
      return <Redirect
        to={{
          pathname: `/${this.state.link}`,
          state: {
            vehicleNumber: this.state.vehicleNumber,
            trackableLabel: this.state.trackableLabel,
            trackableName: this.state.trackableName
          }
        }}
      />
    }
    return (
      <div style={styles.content}>
        <div style={styles.top}>
          <div style={styles.titleContent}>
            <span style={styles.title}>{truncatedValue}</span>
          </div>
          <div>
            {this.checkTicketButton()}
            {this.checkEventButton()}
            {this.checkDashboardButton()}
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  content: {
    height: '48px',
    marginTop: '55px'
  },
  top: {
    height: '50px'
  },
  titleContent: {
    float: 'left'
  },
  title: {
    float: 'left',
    marginLeft: '14px',
    fontSize: '32px',
    fontWeight: 321,
    color: '#FFFFFF'
  }
}

export default HeaderDashboardByVehicleComponent
